import { createTheme } from "@mui/material/styles";

const theme = createTheme({
	palette: {
		primary: {
			main: "#FDFEFF",
		},
		secondary: {
			main: "#292929",
		},
		brand: {
			light: "#eb3b42",
			main: "#e60b13",
			dark: "#a1070d",
			contrastText: "#FCFCFC",
		},
		brandSecondary: {
			light: "#edeff2",
			main: "#e9ecef",
			dark: "#a3a5a7",
			contrastText: "#0a0a0a",
		},
		light: {
			main: "#919494",
		},
		lightBg: {
			main: "#F5F6F7",
		},
		error: {
			main: "#e60b13",
		},
	},
	typography: {
		fontFamily: "Quicksand",
		body1: { fontSize: "1rem" },
		h1: { fontSize: "2rem" },
		h2: { fontSize: "1.5rem" },
		h3: { fontSize: "1rem" },
	},
	components: {
		MuiButton: {
			styleOverrides: {
				contained: {
					fontFamily: "Quicksand",
					textTransform: "capitalize",
					backgroundColor: `#e60b13`,
					borderRadius: "100px",
				},
				outlined: {
					borderRadius: "100px",
				},
			},
		},
		MuiLoadingButton: {
			styleOverrides: {
				contained: {
					fontFamily: "Quicksand",
					textTransform: "capitalize",
					backgroundColor: `#e60b13`,
					borderRadius: "100px",
				},
				outlined: {
					borderRadius: "100px",
				},
			},
		},
		MuiCardMedia: {
			styleOverrides: {
				root: {
					objectFit: "contain",
				},
			},
		},
	},
});

export default theme;
